import { maxiBlockDishesParams } from 'app/components/PromoMaxiBlock/maxiDishes';

export const getMaxiBlockDishes = () => {
    const allMaxiBlocks = document.querySelectorAll('.maxiBlock');
    const selectionsKeys = Array.from(allMaxiBlocks)?.map((node) => node.dataset?.selection_key);
    return selectionsKeys.flatMap((key) => maxiBlockDishesParams[key]?.dishes || []);
};
